<template>
  <div>
    <v-container fluid>
      <!-- Dashboard Statistics Section -->
      <base-material-card
        icon="mdi-chart-bar"
        title="สถิติข้อมูลสถานศึกษา"
        class="px-5 py-3 mb-5"
      >
        <v-row>
          <!-- Summary Cards -->
          <v-col cols="12" sm="6" md="3">
            <v-card class="pa-4" color="primary" dark>
              <div class="d-flex align-center">
                <v-icon size="48" class="mr-3">mdi-school</v-icon>
                <div>
                  <div class="text-h4 font-weight-bold">{{ totalColleges }}</div>
                  <div class="text-subtitle-1">สถานศึกษาทั้งหมด</div>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-card class="pa-4" color="success" dark>
              <div class="d-flex align-center">
                <v-icon size="48" class="mr-3">mdi-checkbox-marked-circle</v-icon>
                <div>
                  <div class="text-h4 font-weight-bold">{{ devColleges }}</div>
                  <div class="text-subtitle-1">สถานศึกษาพัฒนา</div>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-card class="pa-4" color="info" dark>
              <div class="d-flex align-center">
                <v-icon size="48" class="mr-3">mdi-office-building</v-icon>
                <div>
                  <div class="text-h4 font-weight-bold">{{ vecproColleges }}</div>
                  <div class="text-subtitle-1">สอจ.</div>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-card class="pa-4" color="warning" dark>
              <div class="d-flex align-center">
                <v-icon size="48" class="mr-3">mdi-map-marker</v-icon>
                <div>
                  <div class="text-h4 font-weight-bold">{{ totalProvinces }}</div>
                  <div class="text-subtitle-1">จังหวัด</div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Charts Row -->
        <v-row class="mt-4">
          <!-- Pie Chart - ประเภทสถานศึกษา -->
          <v-col cols="12" md="6">
            <v-card class="pa-4">
              <v-card-title class="text-subtitle-1 font-weight-bold">
                <v-icon class="mr-2">mdi-chart-pie</v-icon>
                สัดส่วนประเภทสถานศึกษา
              </v-card-title>
              <apexchart
                type="pie"
                height="350"
                :options="collegeTypeChartOptions"
                :series="collegeTypeSeries"
              ></apexchart>
            </v-card>
          </v-col>

          <!-- Bar Chart - สถานศึกษาแยกตามสถาบัน -->
          <v-col cols="12" md="6">
            <v-card class="pa-4">
              <v-card-title class="text-subtitle-1 font-weight-bold">
                <v-icon class="mr-2">mdi-chart-bar</v-icon>
                สถานศึกษาแยกตามสถาบันการอาชีวศึกษา
              </v-card-title>
              <apexchart
                type="bar"
                height="350"
                :options="veiChartOptions"
                :series="veiSeries"
              ></apexchart>
            </v-card>
          </v-col>
        </v-row>

        <!-- Province Chart -->
        <v-row class="mt-4">
          <v-col cols="12">
            <v-card class="pa-4">
              <v-card-title class="text-subtitle-1 font-weight-bold">
                <v-icon class="mr-2">mdi-chart-line</v-icon>
                สถานศึกษาแยกตามจังหวัด (Top 15)
              </v-card-title>
              <apexchart
                type="bar"
                height="400"
                :options="provinceChartOptions"
                :series="provinceSeries"
              ></apexchart>
            </v-card>
          </v-col>
        </v-row>

        <!-- Donut Chart - สถานศึกษาพัฒนา -->
        <v-row class="mt-4">
          <v-col cols="12" md="6">
            <v-card class="pa-4">
              <v-card-title class="text-subtitle-1 font-weight-bold">
                <v-icon class="mr-2">mdi-chart-donut</v-icon>
                สัดส่วนสถานศึกษาพัฒนา
              </v-card-title>
              <apexchart
                type="donut"
                height="350"
                :options="devChartOptions"
                :series="devSeries"
              ></apexchart>
            </v-card>
          </v-col>

          <!-- Radial Chart - สอจ. -->
          <v-col cols="12" md="6">
            <v-card class="pa-4">
              <v-card-title class="text-subtitle-1 font-weight-bold">
                <v-icon class="mr-2">mdi-chart-arc</v-icon>
                สัดส่วน สอจ.
              </v-card-title>
              <apexchart
                type="radialBar"
                height="350"
                :options="vecproChartOptions"
                :series="vecproSeries"
              ></apexchart>
            </v-card>
          </v-col>
        </v-row>
      </base-material-card>

      <!-- Data Table Section -->
      <base-material-card
        icon="mdi-clipboard-text"
        title="ข้อมูลสถานศึกษา"
        class="px-5 py-3"
      >
        <v-card class="mb-4 pa-2">
          <v-row>
            <v-col cols="12" lg="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
                single-line
                hide-details
                dense
                filled
                class="mb-2"
              />
            </v-col>
            <v-col cols="12" lg="4" class="text-center">
              <v-btn
                large
                depressed
                color="success"
                @click="exportToExcel()"
                class="mr-2"
              >
                <v-icon left>mdi-file-excel</v-icon>
                ส่งออก Excel
              </v-btn>
              <v-btn
                large
                depressed
                color="info"
                @click="exportStatisticsToExcel()"
              >
                <v-icon left>mdi-chart-box</v-icon>
                ส่งออกสถิติ
              </v-btn>
            </v-col>
            <v-col cols="12" lg="4" class="text-right" v-if="user.userauthority_govem != '1'">
              <v-btn
                large
                depressed
                color="primary"
                @click.native="collegeAdd()"
              >
                <v-icon>mdi-plus-circle-outline</v-icon>เพิ่มรายการ
              </v-btn>
            </v-col>
          </v-row>
        </v-card>

        <v-data-table
          color="success"
          :loading="loading"
          :headers="filteredHeaders"
          :items="colleges"
          :search="search"
        >
          <template v-slot:item.index="{ index }">
            {{ index + 1 }}
          </template>

          <template v-slot:item.collegeDev="{ item }">
            <div v-if="item.collegeDev === 'Dev'" class="text-center">
              <v-chip small color="success" dark>
                <v-icon small left>mdi-checkbox-marked-circle-outline</v-icon>
                พัฒนา
              </v-chip>
            </div>
          </template>

          <template v-slot:item.college_vecpro="{ item }">
            <div v-if="item.college_vecpro === '1'" class="text-center">
              <v-chip small color="info" dark>
                <v-icon small left>mdi-checkbox-marked-circle-outline</v-icon>
                สอจ.
              </v-chip>
            </div>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon color="yellow darken-2" @click.stop="collegeEdit(item.college_ID)">
              mdi-pencil
            </v-icon>
          </template>

          <template v-slot:item.action_s="{ item }">
            <v-icon color="red" @click.stop="collegeDelete(item.college_ID)">
              mdi-delete
            </v-icon>
          </template>

          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
          >
            ไม่พบผลลัพธ์ "{{ search }}" ที่คุณกำลังค้นหา.
          </v-alert>
        </v-data-table>
      </base-material-card>

      <!-- Dialogs (เหมือนเดิม) -->
      <!-- addcollegedialog -->
      <v-layout row justify-center>
        <v-dialog v-model="addcollegedialog" persistent max-width="50%">
          <v-card class="mx-auto pa-5">
            <base-material-card
              icon="mdi-account-multiple"
              title="เพิ่มข้อมูลสถานศึกษา"
              class="px-5 py-3 text_google"
            >
            </base-material-card>

            <v-card-text>
              <v-form ref="addcollegeform" lazy-validation>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md12>
                      <v-text-field
                        label="รหัสสถานศึกษา"
                        v-model="addcollege.college_code"
                        required
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md12>
                      <v-text-field
                        label="ชื่อสถานศึกษา"
                        v-model="addcollege.college_name"
                        required
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md12>
                      <v-text-field
                        label="ชื่อย่อสถานศึกษา"
                        v-model="addcollege.collegeIni"
                        required
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md12>
                      <v-autocomplete
                        :items="veivocals"
                        item-text="veiVocalName"
                        item-value="veiVocalID"
                        label="สังกัดสถาบันการอาชีวศึกษา"
                        v-model="addcollege.collegeVei"
                        required
                        :rules="[v => !!v || '']"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex md6>
                      <v-autocomplete
                        label="จังหวัด"
                        v-model="addcollege.province_ID"
                        :items="provinces"
                        item-text="province_name"
                        item-value="province_ID"
                        required
                        :rules="[v => !!v || '']"
                        @change="prefectureQuery()"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex md6>
                      <v-autocomplete
                        label="อำเภอ"
                        v-model="addcollege.prefecture_ID"
                        :items="prefectures"
                        item-text="prefecture_name"
                        item-value="prefecture_ID"
                        required
                        :rules="[v => !!v || '']"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex md6>
                      <v-autocomplete
                        label="ประเภท"
                        v-model="addcollege.collegetype_ID"
                        :items="collegetypes"
                        item-text="collegetype_name"
                        item-value="collegetype_ID"
                        required
                        :rules="[v => !!v || '']"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex md6>
                      <v-autocomplete
                        label="ประเภทสถานศึกษาคำนวณอัตรากำลัง"
                        v-model="addcollege.college_id_code_type_manpower"
                        :items="college_type_manpowers"
                        item-text="name_ctm"
                        item-value="id_code_ctm"
                        required
                        :rules="[v => !!v || '']"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex md6>
                      <v-switch
                        v-model="addcollege.collegeDevSW"
                        inset
                        label="สถานศึกษาพัฒนาคุณภาพการศึกษา : ใช่/ไม่ใช่"
                        prepend-icon="mdi-eye"
                      ></v-switch>
                    </v-flex>
                    <v-flex md6> Password : {{ user_passwords }} </v-flex>
                  </v-layout>
                </v-container>
                <small>* จำเป็น</small>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="warning"
                large
                @click.stop="addcollegedialog = false"
                rounded
              >
                <v-icon dark>mdi-close</v-icon> ยกเลิก
              </v-btn>
              <v-btn
                large
                color="success"
                @click.stop="addcollegeSubmit()"
                rounded
              >
                <v-icon dark>mdi-content-save</v-icon>&nbsp;&nbsp;บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model deletecollegedialog -->
      <v-layout>
        <v-dialog v-model="deletecollegedialog" persistent max-width="40%">
          <v-card class="mx-auto pa-5">
            <base-material-card
              color="error"
              icon="mdi-delete"
              title="ลบข้อมูลสถานศึกษา"
              class="px-5 py-3 text_google"
            >
            </base-material-card>

            <v-card-text class="text_google">
              <v-card>
                <v-card-text>
                  <v-form ref="deletecollegeform" lazy-validation>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12>
                          ยืนยันการลบข้อมูล <br />
                          {{ editcollege.college_name }}
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click.stop="deletecollegedialog = false">
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="red darken-3"
                @click.stop="deletecollegeSubmit()"
                dark
              >
                <v-icon dark>mdi-delete</v-icon>&nbsp;ลบ
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model editcollegedialog -->
      <v-layout row justify-center>
        <v-dialog v-model="editcollegedialog" persistent max-width="80%">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="yellow"
              icon="mdi-clipboard-text"
              title="แก้ไขข้อมูลผู้ใช้งานระบบ"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form ref="editcollegeform" lazy-validation>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md12>
                      <v-text-field
                        label="รหัสสถานศึกษา"
                        v-model="editcollege.college_code"
                        required
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md12>
                      <v-text-field
                        label="ชื่อสถานศึกษา"
                        v-model="editcollege.college_name"
                        required
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md12>
                      <v-text-field
                        label="ชื่อย่อสถานศึกษา"
                        v-model="editcollege.collegeIni"
                        required
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md12>
                      <v-autocomplete
                        :items="veivocals"
                        item-text="veiVocalName"
                        item-value="veiVocalID"
                        label="สังกัดสถาบันการอาชีวศึกษา"
                        v-model="editcollege.collegeVei"
                        required
                        :rules="[v => !!v || '']"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex md6>
                      <v-autocomplete
                        label="จังหวัด"
                        v-model="editcollege.province_ID"
                        :items="provinces"
                        item-text="province_name"
                        item-value="province_ID"
                        required
                        :rules="[v => !!v || '']"
                        @change="prefectureQueryEdit()"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex md6>
                      <v-autocomplete
                        label="อำเภอ"
                        v-model="editcollege.prefecture_ID"
                        :items="prefectures"
                        item-text="prefecture_name"
                        item-value="prefecture_ID"
                        required
                        :rules="[v => !!v || '']"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex md6>
                      <v-autocomplete
                        label="ประเภท"
                        v-model="editcollege.collegetype_ID"
                        :items="collegetypes"
                        item-text="collegetype_name"
                        item-value="collegetype_ID"
                        required
                        :rules="[v => !!v || '']"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex md6>
                      <v-autocomplete
                        label="ประเภทสถานศึกษาคำนวณอัตรากำลัง"
                        v-model="editcollege.college_id_code_type_manpower"
                        :items="college_type_manpowers"
                        item-text="name_ctm"
                        item-value="id_code_ctm"
                        required
                        :rules="[v => !!v || '']"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex md6>
                      <v-switch
                        v-model="editcollege.collegeDevSW"
                        inset
                        label="สถานศึกษาพัฒนาคุณภาพการศึกษา : ใช่/ไม่ใช่"
                        prepend-icon="mdi-eye"
                      ></v-switch>
                    </v-flex>
                    <v-flex md6>
                      <v-radio-group v-model="editcollege.college_vecpro" row>
                        <template v-slot:label>
                          <div>
                            สำนักงานอาชีวศึกษาจังหวัด
                            <strong>เป็น/ไม่เป็น</strong>
                          </div>
                        </template>
                        <v-radio label="เป็น สอจ." value="1"></v-radio>
                        <v-radio label="ไม่เป็น สอจ." value="0"></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                </v-container>
                <small>* จำเป็น</small>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click.stop="editcollegedialog = false" rounded>
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="warning"
                @click.stop="editcollegeSubmit()"
                rounded
              >
                <v-icon dark>mdi-pencil</v-icon>&nbsp;บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>

    <v-container fluid>
      <v-snackbar
        v-model="snackbar.show"
        top
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        <v-icon large>{{ snackbar.icon }}</v-icon>
        <v-card-text>
          {{ snackbar.text }}
        </v-card-text>

        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">Close</v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import * as XLSX from "xlsx";

export default {
  data() {
    return {
      loading: true,
      ApiKey: "HRvec2021",
      valid: true,
      addcollegedialog: false,
      editcollegedialog: false,
      deletecollegedialog: false,
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      colleges: [],
      addcollege: {},
      editcollege: {},
      userstatus: [],
      search: "",
      pagination: {},
      headers: [
        { text: "รหัสสถานศึกษา", align: "left", value: "college_code" },
        { text: "ชื่อสถานศึกษา", align: "left", value: "college_name" },
        { text: "ชื่อย่อ", align: "left", value: "collegeIni" },
        { text: "สถาบันการอาชีวศึกษา", align: "left", value: "veiVocalName" },
        { text: "อำเภอ", align: "left", value: "prefecture_name" },
        { text: "จังหวัด", align: "left", value: "province_name" },
        { text: "ประเภท", align: "left", value: "collegetype_name" },
        { text: "สถานศึกษาพัฒนา", align: "center", value: "collegeDev" },
        { text: "สอจ.", align: "center", value: "college_vecpro" },
        {
          text: "แก้ไข",
          align: "center",
          value: "actions",
          icon: "mdi-file-document-edit",
          sortable: false
        },
        {
          text: "ลบ",
          align: "center",
          value: "action_s",
          icon: "mdi-delete-forever",
          sortable: false
        }
      ],
      rowsperpage: [25, 50, 100, { text: "All", value: -1 }],
      college: {},
      provinces: [],
      prefectures: [],
      collegetypes: [],
      collgegs: [],
      collegestatus: [],
      regions: [],
      region_ena: true,
      user_update: {},
      collegeinfo_update: {},
      veivocals: [],
      college_type_manpowers: [],
      addcollegeinfo: {},
      deleteCollegeinfo: {},
      adduser: {},
      user_passwords: [],
      delUser: {},
      user: [],

      // Chart Options
      collegeTypeChartOptions: {
        chart: {
          type: "pie",
          toolbar: {
            show: true,
            tools: {
              download: true
            }
          }
        },
        labels: [],
        colors: ["#1976D2", "#388E3C", "#F57C00", "#D32F2F", "#7B1FA2", "#0097A7"],
        legend: {
          position: "bottom",
          fontSize: "14px"
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 300
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ],
        dataLabels: {
          enabled: true,
          formatter: function(val) {
            return val.toFixed(1) + "%";
          }
        }
      },
      collegeTypeSeries: [],

      veiChartOptions: {
        chart: {
          type: "bar",
          toolbar: {
            show: true
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 4,
            dataLabels: {
              position: "top"
            }
          }
        },
        colors: ["#1976D2"],
        dataLabels: {
          enabled: true,
          offsetX: 20,
          style: {
            fontSize: "12px",
            colors: ["#333"]
          }
        },
        xaxis: {
          categories: []
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "11px"
            }
          }
        }
      },
      veiSeries: [{ name: "จำนวน", data: [] }],

      provinceChartOptions: {
        chart: {
          type: "bar",
          toolbar: {
            show: true
          }
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            columnWidth: "60%",
            distributed: true
          }
        },
        colors: [
          "#1976D2", "#388E3C", "#F57C00", "#D32F2F", "#7B1FA2",
          "#0097A7", "#C2185B", "#512DA8", "#00796B", "#FBC02D",
          "#5D4037", "#455A64", "#E64A19", "#1565C0", "#2E7D32"
        ],
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "11px"
          }
        },
        legend: {
          show: false
        },
        xaxis: {
          categories: [],
          labels: {
            rotate: -45,
            style: {
              fontSize: "11px"
            }
          }
        }
      },
      provinceSeries: [{ name: "จำนวน", data: [] }],

      devChartOptions: {
        chart: {
          type: "donut"
        },
        labels: ["สถานศึกษาพัฒนา", "สถานศึกษาทั่วไป"],
        colors: ["#4CAF50", "#9E9E9E"],
        legend: {
          position: "bottom"
        },
        dataLabels: {
          enabled: true,
          formatter: function(val, opts) {
            return opts.w.config.series[opts.seriesIndex];
          }
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "รวม",
                  fontSize: "16px"
                }
              }
            }
          }
        }
      },
      devSeries: [],

      vecproChartOptions: {
        chart: {
          type: "radialBar"
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: "70%"
            },
            dataLabels: {
              name: {
                fontSize: "16px"
              },
              value: {
                fontSize: "24px",
                formatter: function(val) {
                  return val + "%";
                }
              }
            }
          }
        },
        labels: ["สัดส่วน สอจ."],
        colors: ["#2196F3"]
      },
      vecproSeries: []
    };
  },

  async mounted() {
    await this.userQueryAll();
    await this.collegeQueryAll();
    await this.veivocalQueryAll();
    await this.provinceQuery();
    await this.collegetypeQuery();
    await this.college_type_manpowerQuery();
  },

  methods: {
    async userQueryAll() {
      let result;
      let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
      result = await this.$http.post("user.php", {
        ApiKey: this.ApiKey,
        user_ID: userSession.user_ID
      });
      this.user = result.data;
    },

    async collegeQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("college.php", {
          ApiKey: this.ApiKey
        })
        .finally(() => (this.loading = false));
      this.colleges = result.data;
      this.updateCharts();
    },

    updateCharts() {
      // Update College Type Chart
      const typeCount = {};
      this.colleges.forEach(college => {
        const type = college.collegetype_name || "ไม่ระบุ";
        typeCount[type] = (typeCount[type] || 0) + 1;
      });
      this.collegeTypeChartOptions = {
        ...this.collegeTypeChartOptions,
        labels: Object.keys(typeCount)
      };
      this.collegeTypeSeries = Object.values(typeCount);

      // Update VEI Chart
      const veiCount = {};
      this.colleges.forEach(college => {
        const vei = college.veiVocalName || "ไม่ระบุ";
        veiCount[vei] = (veiCount[vei] || 0) + 1;
      });
      const sortedVei = Object.entries(veiCount).sort((a, b) => b[1] - a[1]);
      this.veiChartOptions = {
        ...this.veiChartOptions,
        xaxis: {
          categories: sortedVei.map(item => item[0])
        }
      };
      this.veiSeries = [{ name: "จำนวน", data: sortedVei.map(item => item[1]) }];

      // Update Province Chart (Top 15)
      const provinceCount = {};
      this.colleges.forEach(college => {
        const province = college.province_name || "ไม่ระบุ";
        provinceCount[province] = (provinceCount[province] || 0) + 1;
      });
      const sortedProvince = Object.entries(provinceCount)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 15);
      this.provinceChartOptions = {
        ...this.provinceChartOptions,
        xaxis: {
          ...this.provinceChartOptions.xaxis,
          categories: sortedProvince.map(item => item[0])
        }
      };
      this.provinceSeries = [
        { name: "จำนวน", data: sortedProvince.map(item => item[1]) }
      ];

      // Update Dev Chart
      const devCount = this.colleges.filter(c => c.collegeDev === "Dev").length;
      const nonDevCount = this.colleges.length - devCount;
      this.devSeries = [devCount, nonDevCount];

      // Update Vecpro Chart
      const vecproCount = this.colleges.filter(c => c.college_vecpro === "1").length;
      const vecproPercent = this.colleges.length > 0 
        ? Math.round((vecproCount / this.colleges.length) * 100) 
        : 0;
      this.vecproSeries = [vecproPercent];
    },

    exportToExcel() {
      const exportData = this.colleges.map((item, index) => ({
        ลำดับ: index + 1,
        รหัสสถานศึกษา: item.college_code,
        ชื่อสถานศึกษา: item.college_name,
        ชื่อย่อ: item.collegeIni,
        สถาบันการอาชีวศึกษา: item.veiVocalName,
        อำเภอ: item.prefecture_name,
        จังหวัด: item.province_name,
        ประเภท: item.collegetype_name,
        สถานศึกษาพัฒนา: item.collegeDev === "Dev" ? "ใช่" : "ไม่ใช่",
        สอจ: item.college_vecpro === "1" ? "ใช่" : "ไม่ใช่"
      }));

      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "ข้อมูลสถานศึกษา");

      // Auto-fit column widths
      const colWidths = [
        { wch: 8 },  // ลำดับ
        { wch: 15 }, // รหัสสถานศึกษา
        { wch: 40 }, // ชื่อสถานศึกษา
        { wch: 15 }, // ชื่อย่อ
        { wch: 30 }, // สถาบันการอาชีวศึกษา
        { wch: 20 }, // อำเภอ
        { wch: 20 }, // จังหวัด
        { wch: 25 }, // ประเภท
        { wch: 15 }, // สถานศึกษาพัฒนา
        { wch: 10 }  // สอจ
      ];
      ws["!cols"] = colWidths;

      const date = new Date().toLocaleDateString("th-TH");
      XLSX.writeFile(wb, `ข้อมูลสถานศึกษา_${date}.xlsx`);

      this.snackbar = {
        show: true,
        color: "success",
        icon: "mdi-check-circle",
        text: "ส่งออกข้อมูลเป็น Excel เรียบร้อยแล้ว",
        timeout: 3000
      };
    },

    exportStatisticsToExcel() {
      const wb = XLSX.utils.book_new();

      // Sheet 1: Summary
      const summaryData = [
        { รายการ: "สถานศึกษาทั้งหมด", จำนวน: this.totalColleges },
        { รายการ: "สถานศึกษาพัฒนา", จำนวน: this.devColleges },
        { รายการ: "สอจ.", จำนวน: this.vecproColleges },
        { รายการ: "จำนวนจังหวัด", จำนวน: this.totalProvinces }
      ];
      const wsSummary = XLSX.utils.json_to_sheet(summaryData);
      XLSX.utils.book_append_sheet(wb, wsSummary, "สรุปภาพรวม");

      // Sheet 2: By College Type
      const typeCount = {};
      this.colleges.forEach(college => {
        const type = college.collegetype_name || "ไม่ระบุ";
        typeCount[type] = (typeCount[type] || 0) + 1;
      });
      const typeData = Object.entries(typeCount).map(([type, count]) => ({
        ประเภทสถานศึกษา: type,
        จำนวน: count,
        สัดส่วน: ((count / this.colleges.length) * 100).toFixed(2) + "%"
      }));
      const wsType = XLSX.utils.json_to_sheet(typeData);
      XLSX.utils.book_append_sheet(wb, wsType, "แยกตามประเภท");

      // Sheet 3: By Province
      const provinceCount = {};
      this.colleges.forEach(college => {
        const province = college.province_name || "ไม่ระบุ";
        provinceCount[province] = (provinceCount[province] || 0) + 1;
      });
      const provinceData = Object.entries(provinceCount)
        .sort((a, b) => b[1] - a[1])
        .map(([province, count]) => ({
          จังหวัด: province,
          จำนวน: count,
          สัดส่วน: ((count / this.colleges.length) * 100).toFixed(2) + "%"
        }));
      const wsProvince = XLSX.utils.json_to_sheet(provinceData);
      XLSX.utils.book_append_sheet(wb, wsProvince, "แยกตามจังหวัด");

      // Sheet 4: By VEI
      const veiCount = {};
      this.colleges.forEach(college => {
        const vei = college.veiVocalName || "ไม่ระบุ";
        veiCount[vei] = (veiCount[vei] || 0) + 1;
      });
      const veiData = Object.entries(veiCount)
        .sort((a, b) => b[1] - a[1])
        .map(([vei, count]) => ({
          สถาบันการอาชีวศึกษา: vei,
          จำนวน: count,
          สัดส่วน: ((count / this.colleges.length) * 100).toFixed(2) + "%"
        }));
      const wsVei = XLSX.utils.json_to_sheet(veiData);
      XLSX.utils.book_append_sheet(wb, wsVei, "แยกตามสถาบัน");

      const date = new Date().toLocaleDateString("th-TH");
      XLSX.writeFile(wb, `สถิติสถานศึกษา_${date}.xlsx`);

      this.snackbar = {
        show: true,
        color: "success",
        icon: "mdi-check-circle",
        text: "ส่งออกสถิติเป็น Excel เรียบร้อยแล้ว",
        timeout: 3000
      };
    },

    async veivocalQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("veivocal.php", {
          ApiKey: this.ApiKey
        })
        .finally(() => (this.loading = false));
      this.veivocals = result.data;
    },

    async provinceQuery() {
      let result_provin = await this.$http.post("province.php", {
        ApiKey: this.ApiKey
      });
      this.provinces = result_provin.data;
    },

    async prefectureQuery() {
      let result_prefec = await this.$http.post("prefecture.php", {
        ApiKey: this.ApiKey,
        province_ID: this.addcollege.province_ID
      });
      this.prefectures = result_prefec.data;
    },

    async prefectureQueryEdit() {
      let result_prefec = await this.$http.post("prefecture.php", {
        ApiKey: this.ApiKey,
        province_ID: this.editcollege.province_ID
      });
      this.prefectures = result_prefec.data;
    },

    async collegetypeQuery() {
      let result_collegety = await this.$http.post("collegetype.php", {
        ApiKey: this.ApiKey
      });
      this.collegetypes = result_collegety.data;
    },

    async college_type_manpowerQuery() {
      let result_collegety = await this.$http.post(
        "college_type_manpower.php",
        {
          ApiKey: this.ApiKey
        }
      );
      this.college_type_manpowers = result_collegety.data;
    },

    async regionQuery() {
      let result_region = await this.$http.post("region.php", {
        ApiKey: this.ApiKey
      });
      this.regions = result_region.data;
    },

    async collegeAdd() {
      this.addcollege = {};
      this.makeid();
      this.addcollegedialog = true;
    },

    async addcollegeSubmit() {
      if (this.$refs.addcollegeform.validate()) {
        this.addcollege.ApiKey = this.ApiKey;
        this.addcollegeinfo.ApiKey = this.ApiKey;
        this.adduser.ApiKey = this.ApiKey;
        this.adduser.user_code = this.addcollege.college_code;
        this.adduser.user_name = this.addcollege.college_code;
        this.adduser.user_password = this.user_passwords;
        this.adduser.user_firstname = this.addcollege.college_name;
        this.adduser.user_lastname = this.addcollege.college_name;
        this.adduser.user_status = "B";

        this.addcollegeinfo.collegeinfo_code = this.addcollege.college_code;

        if (this.addcollege.collegeDevSW == true) {
          this.addcollege.collegeDev = "Dev";
        } else {
          this.addcollege.collegeDev = "";
        }
        let result = await this.$http.post(
          "college.insert.php",
          this.addcollege
        );

        let result_info = await this.$http.post(
          "collegeinfo.insert.php",
          this.addcollegeinfo
        );
        let result_user = await this.$http.post(
          "user.insert.php",
          this.adduser
        );
        if (
          result.data.status == true &&
          result_info.data.status == true &&
          result_user.data.status == true
        ) {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.collegeQueryAll();
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
          this.collegeQueryAll();
        }
        this.addcollegedialog = false;
      }
    },

    async collegeEdit(college_ID) {
      let result = await this.$http.post("college.php", {
        ApiKey: this.ApiKey,
        college_ID: college_ID
      });
      this.editcollege = result.data;
      if (this.editcollege.collegeDev == "Dev") {
        this.editcollege.collegeDevSW = true;
      } else {
        this.editcollege.collegeDevSW = false;
      }
      
      // Load prefectures for edit
      await this.prefectureQueryEdit();
      
      this.editcollegedialog = true;
    },

    async editcollegeSubmit() {
      if (this.$refs.editcollegeform.validate()) {
        this.editcollege.ApiKey = this.ApiKey;

        if (this.editcollege.collegeDevSW == true) {
          this.editcollege.collegeDev = "Dev";
        } else {
          this.editcollege.collegeDev = "";
        }

        this.user_update.ApiKey = this.ApiKey;
        this.user_update.user_code = this.editcollege.college_code;
        this.user_update.user_firstname = this.editcollege.college_name;

        this.collegeinfo_update.ApiKey = this.ApiKey;
        this.collegeinfo_update.collegeinfo_code = this.editcollege.college_code;

        let result = await this.$http.post(
          "college.update.php",
          this.editcollege
        );

        let result_user = await this.$http.post(
          "user.update.code.php",
          this.user_update
        );

        let result_collegeinfo = await this.$http.post(
          "collegeinfo.update.code.php",
          this.collegeinfo_update
        );

        if (result.data.status == true) {
          this.college = result.data;
          Swal.fire({
            icon: "success",
            title: "ดำเนินการแก้ไขข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.collegeQueryAll();
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
          this.collegeQueryAll();
        }
        this.editcollegedialog = false;
      }
    },

    async collegeDelete(college_ID) {
      let result = await this.$http.post("college.php", {
        ApiKey: this.ApiKey,
        college_ID: college_ID
      });
      this.editcollege = result.data;
      this.deletecollegedialog = true;
    },

    async deletecollegeSubmit() {
      if (this.$refs.deletecollegeform.validate()) {
        this.editcollege.ApiKey = this.ApiKey;
        this.deleteCollegeinfo.ApiKey = this.ApiKey;
        this.delUser.ApiKey = this.ApiKey;
        this.delUser.user_code = this.editcollege.college_code;

        this.deleteCollegeinfo.collegeinfo_code = this.editcollege.college_code;

        let result = await this.$http.post(
          "college.delete.php",
          this.editcollege
        );
        let resultCollegeinfo = await this.$http.post(
          "collegeinfo.delete.php",
          this.deleteCollegeinfo
        );
        let resultUser = await this.$http.post(
          "user.college.delete.php",
          this.delUser
        );

        if (
          result.data.status == true &&
          resultCollegeinfo.data.status == true &&
          resultUser.data.status == true
        ) {
          this.college = result.data;
          Swal.fire({
            icon: "success",
            title: "ดำเนินการลบข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.collegeQueryAll();
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการลบผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.deletecollegedialog = false;
      }
    },

    async makeid() {
      let result = "";
      let characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let charactersLength = characters.length;
      for (let i = 0; i < 8; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      this.user_passwords = result;
    }
  },

  computed: {
    filteredHeaders() {
      if (this.user.userauthority_govem === "1") {
        return this.headers.filter(
          h => h.value !== "actions" && h.value !== "action_s"
        );
      }
      return this.headers;
    },

    totalColleges() {
      return this.colleges.length;
    },

    devColleges() {
      return this.colleges.filter(c => c.collegeDev === "Dev").length;
    },

    vecproColleges() {
      return this.colleges.filter(c => c.college_vecpro === "1").length;
    },

    totalProvinces() {
      const provinces = new Set(this.colleges.map(c => c.province_name));
      return provinces.size;
    },

    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  }
};
</script>

<style scoped>
.text-h4 {
  font-size: 2rem !important;
}
</style>